export const getInitialSettingsData = (accountId: string) => {
  return {
    accountId,
    analyticsEnabled: false,
    analyticsSharedUserEnabled: false
  };
};
